import { z } from 'zod';

/** Reporter-provided context, shared across manual, assistant and external intake creation. */
export const reportContextFields = {
  screenName: z.string().trim().max(200).optional(),
  screenUrl: z
    .string()
    .trim()
    .max(2048)
    .refine((value) => {
      if (!value) return true;
      try {
        const url = new URL(value);
        return ['http:', 'https:'].includes(url.protocol) && !url.username && !url.password;
      } catch {
        return false;
      }
    }, 'Enter an http or https URL without credentials.')
    .optional(),
  exampleData: z.string().max(20_000).optional(),
};
export const reportContext = z.object(reportContextFields);
export type ReportContext = z.infer<typeof reportContext>;
export const intakePrefill = reportContext.extend({
  title: z.string().max(200).optional(),
  description: z.string().max(50_000).optional(),
  stepsOrOutcome: z.string().max(20_000).optional(),
});
export type IntakePrefill = z.infer<typeof intakePrefill>;
export const selectedAttachmentIds = z
  .array(z.string().uuid())
  .max(20)
  .refine((ids) => new Set(ids).size === ids.length, 'Each attachment may be selected only once.')
  .optional();
export const MEDIA_ACCEPT =
  'image/png,image/jpeg,image/gif,image/webp,video/mp4,video/webm,video/quicktime,.mp4,.webm,.mov,.txt,.log,.csv,.md,.json,.pdf';
